<template>
  <div class="clearfix">
    <vs-input
      v-validate="'required|alpha_dash|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Name"
      name="displayName"
      placeholder="Name"
      v-model="displayName"
      class="w-full" />
    <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      :label-placeholder="$t('Email')"
      :placeholder="$t('Email')"
      v-model="email"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      v-validate="'required|numeric|min:10'"
      data-vv-validate-on="blur"
      name="phoneNumber"
      type="text"
      :label-placeholder="$t('PhoneNumber')"
      :placeholder="$t('PhoneNumber')"
      v-model="phoneNumber"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>

    <v-select
      v-validate="'required'"
      data-vv-validate-on="blur"
      name="name"
      :label-placeholder="$t('Role')"
      :placeholder="$t('Choose The Role')"
      v-model="userType"
      :options="roles"
      :reduce="co => co.name"
      @input="checkRole"
      label="name"
      class="w-full mt-6 custom-select-height" />
    <span class="text-danger text-sm">{{ errors.first('userType') }}</span>

    <div v-if="userType=='NationalManager' || userType=='SubNationalManager'">
          <p class="mt-5" style="font-size: 12px;">{{ $t('Country') }}</p>
          <v-select class="w-full"
           name="Name"
           label="Name"
           v-if="!isResetPassword" v-model="countryId"
            :options="countries" :reduce="co => co.ID" @input="checkCountry" />
        </div>

        <div v-if="userType=='SubNationalManager'">
          <p class="mt-5" style="font-size: 12px;">{{ $t('Admin LVL1') }}</p>
          <v-select class="w-full"
           name="Name"
           label="Name"
           v-if="!isResetPassword" v-model="governorateId"
            :options="governorates" :reduce="co => co.Id" />
        </div>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6|max:10'"
      name="password"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
      type="password"
      v-validate="'min:6|max:10|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">{{$t('AcceptTerms')}}.</vs-checkbox>
    <vs-button type="border" to="/pages/login" class="mt-6">Login</vs-button>
    <vs-button class="float-right mt-6" @click="registerUserJWt" :disabled="!validateForm">{{$t('Register')}}</vs-button>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import moduleCountry from "@/store/settings/Country/moduleCountry.js";
import moduleUser from "@/store/user/moduleUser.js";
//import moduleGovernorate from "@/store/settings/Governorate/moduleGovernorate.js";

export default {
    components: {
        vSelect
    },
    data() {
        return {
            displayName: '',
            email: '',
            password: '',
            confirm_password: '',
            phoneNumber: '',
            isTermsConditionAccepted: true,
            userType: null,
            countryId: null,
            governorateId: null
        }
    },
    created(){

      if (!moduleUser.isRegistered) {
      this.$store.registerModule("UserList", moduleUser);
      moduleUser.isRegistered = true;
    }

    
    this.$store.dispatch("UserList/GetAllRoles");
      if (!moduleCountry.isRegistered) {
      this.$store.registerModule("countryList", moduleCountry);
      moduleCountry.isRegistered = true;
    }
    
    this.$store.dispatch("countryList/fetchDataListItems");

    if (!moduleGovernorate.isRegistered) {
      this.$store.registerModule("GovernorateList", moduleGovernorate);
      moduleGovernorate.isRegistered = true;
    }

    //this.$store.dispatch("GovernorateList/fetchDataListItems");
    },
    computed: {

      roles() {
      
      return this.$store.state.UserList.roles;
    },
      countries() {
     
       return this.$store.state.countryList.countries;
   },

  //  governorates() {
  //    
  //      return this.$store.state.GovernorateList.Governorates;
  //  },
        validateForm() {
            return !this.errors.any() && (this.userType==='SubNationalManager'? (this.governorateId !== null && this.countryId !== null) : (this.userType === 'NationalManager'? this.countryId !== null : (this.countryId===null && this.governorateId === null))) && this.displayName !== '' && this.email !== '' && this.password !== '' && this.confirm_password !== '' && this.isTermsConditionAccepted && this.userType !== null && this.phoneNumber !== '';
        }
    },
    methods: {
        checkLogin() {
          // If user is already logged in notify
          if(this.$store.state.auth.isUserLoggedIn()) {
            this.$vs.notify({
              title: 'Login Attempt',
              text: this.$t("Youarealreadyloggedin")+'!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
            return false
          }
          return true
        },
        checkCountry(){
          if(this.countryId != null){
            this.governorateId=null;
            
           this.$store.dispatch("GovernorateList/GetGovernoratesByCountryID", this.countryId).then((res) => {
           this.governorates = res.data;
         });
       }},
        checkRole(){
        if(this.userType !=='NationalManager' && this.userType !== 'SubNationalManager')
           this.countryId = null;
        if(this.userType !== 'SubNationalManager')
           this.governorateId=null;
        },
        registerUserJWt() {
            // If form is not validated or user is already login return
            if (!this.validateForm || !this.checkLogin()) return

            const payload = {
              userDetails: {
                displayName: this.displayName,
                email: this.email,
                password: this.password,
                phoneNumber: this.phoneNumber,
                confirmPassword: this.confirm_password,
                userType: this.userType,
                countryId: this.countryId,
                governorateId: this.governorateId
              },
              notify: this.$vs.notify
            }
            
            this.$store.dispatch('auth/registerUserJWT', payload).catch((err) => {
                

                this.$vs.notify({
                  time: 2500,
                  title: 'Error',
                  text: err.response.data.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
              });
                console.error(err);
              });
        }
    }
}
</script>

<style scoped>
.v-select .vs__dropdown-toggle {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.375rem 0.75rem;
}

.v-select .vs__selected-options {
  display: flex;
  align-items: center;
  height: 38px;
}

.v-select .vs__actions {
  margin-left: auto;
}

.v-select .vs__dropdown-menu {
  width: 100%;
}

.custom-select-height .vs__selected-options {
  height: 38px;
}
</style>
